import request from '@/utils/request'
import { apiUrl, getwayurl } from './config'
import { starHeaders } from './starApiCommon'

const BASE = apiUrl + '/rjhy-factor-selector/api/1'

type dataType = any

export default {

  /**
   * 我的自选股列表
   */
  getMyOptionalStocks(data?: dataType): Promise<any> {
    return request({
      url: apiUrl + '/optional-info/api/1/strategy/user/optional/list',
      method: 'get',
      params: data?.data,
      headers: starHeaders(data?.headers),
      sign: true,
      newSign: true
    })
  },

  /**
   * 组合 - 一键回测
   */
  doTestCom(data: dataType): Promise<any> {
    return request({
      url: BASE + '/quantstar/dotest/com',
      method: 'post',
      data: data.data,
      headers: starHeaders(data.headers),
      sign: true,
      newSign: true
    })
  },

 

  /**
   * 预设参数 - 个股量化
   */
  getStockOneOptions(data?: dataType): Promise<any> {
    return request({
      url: BASE + '/quantstar/stockone/options',
      method: 'get',
      params: data?.data,
      headers: starHeaders(data?.headers),
      sign: true,
      newSign: true
    })
  },

  /**
   * 一键回测 - 个股智能
   */
  doTestAi(data: dataType): Promise<any> {
    return request({
      url: BASE + '/quantstar/dotest/ai',
      method: 'post',
      data: data.data,
      headers: starHeaders({
        'Content-Type': 'application/json',
        ...data.headers
      }),
      sign: true,
      newSign: true
    })
  },

  /**
   * 一键回测 - 个股自定义
   */
  doTestCustom(data: dataType): Promise<any> {
    return request({
      url: BASE + '/quantstar/dotest/custom',
      method: 'post',
      data: data.data,
      headers: starHeaders({
        'Content-Type': 'application/json',
        ...data.headers
      }),
      sign: true,
      newSign: true
    })
  },

  /**
   * 个股搜索
   */
  searchStock(data?: dataType): Promise<any> {
    return request({
      url: apiUrl + '/rjhy-quote-search/api/1/stock/entrance',
      method: 'get',
      params: {
        markets: 'sh,sz,bj',
        marketIdTypes: '1-2,0-6,3-42,1-27,0-80',
        codeType: 0,
        types: 'security_all',
        pageSize: 20,
        lastIpoDateDays: 60,
        notTag: 'st',
        pageNo: 0,
        ...data?.data
      },
      headers: starHeaders(data?.headers),
      sign: true,
      newSign: true
    })
  },

  /**
   * 星级量化-复制策略-个股
   * @see YApi 94551 POST /quantstar/copycustom
   */
  copyCustomStrategy(data: dataType): Promise<any> {
    return request({
      url: BASE + '/quantstar/copycustom',
      method: 'post',
      data: data.data,
      headers: starHeaders(data.headers),
      sign: true,
      newSign: true
    })
  },

  /**
   * 个股量化 - 操作记录
   */
  getStockOpLog(data?: dataType): Promise<any> {
    return request({
      url: BASE + '/quantstar/oplog/stock',
      method: 'get',
      params: data?.data,
      headers: starHeaders(data?.headers),
      sign: true,
      newSign: true
    })
  },

}

